import * as React from 'react';
import * as ReactDOM from 'react-dom';

import {RouteComponentProps} from 'react-router';
import ListeningComponent from '../../foundation/components/ListeningComponent';
import { History } from 'history';
import AppEvent from '../../foundation/events/AppEvent';
import {Helmet} from 'react-helmet';
import PageHeaderComponent from './components/shared/PageHeaderComponent';
import ModalsComponent from './components/shared/ModalsComponent';
import ModalEvent from '../../foundation/events/ModalEvent';
import DelayedLoader from './components/shared/DelayedLoader';
import { Divider } from 'semantic-ui-react';

declare const MathJax: any;

abstract class Page<P extends RouteComponentProps<any>, S> extends ListeningComponent<P, S> {

	public static history: History;
	private static mathJaxIsConfigured = false;
	private static instance: Page<any, any>;

	private static typesettingTimer: number | null = null;

	public constructor (props: P) {
		super();

		Page.instance = this;
		Page.history = props.history;
	}

	public static navigate (path: string) {
		this.history.push(path);
	}

	public static requestTypesetting (immediate?: boolean) {
		if (this.typesettingTimer !== null) {
			clearTimeout(this.typesettingTimer);
		}

		if (immediate) {
			Page.instance.typeset();
		} else {
			this.typesettingTimer = setTimeout(() => Page.instance.typeset(), 100);
		}
	}

	public async processEvent (event: AppEvent) {
		if (event instanceof ModalEvent) {
			this.forceUpdate();
		}

		return;
	}

	render () {
		return (
			<div style={{minHeight: '100%'}}>
				<Helmet>
					<title>{this.isLoading() ? '' : this.renderTitle()}</title>
					<meta name='description' content={this.isLoading() ? '' : this.renderDescription()} />
					{this.shouldBeIndexed() ? null : <meta name='robots' content='noindex, nofollow' />}
					<script type='text/javascript' async src='https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-MML-AM_CHTML&delayStartupUntil=configured' />
					{this.getCanonicalUrl() === null ? '' : <link rel='canonical' href={'https://brainbrooder.com' + this.getCanonicalUrl()} />}
				</Helmet>

				<PageHeaderComponent pageName={this.getPageName()} />

				<div className='page-content' style={{position: 'relative', padding: this.isPadded() ? '72px 0 89px 0' : 0}}>
					<div style={{padding: this.isPadded() ? '0 16px' : 0}}>
						{this.isLoading() ? <DelayedLoader /> : this.renderContent()}
					</div>

					<div style={{position: 'absolute', bottom: 0, width: '100%', height: '39px', background: '#000000'}}>
						<div style={{width: '720px', margin: 'auto', padding: '10px', fontSize: '14px'}}>
							<a href='/mission'>Mission</a>
							<a href='/contact' style={{marginLeft: '32px'}}>Contact</a>
						</div>
					</div>
				</div>

				<ModalsComponent/>
			</div>
		);
	}

	protected abstract isLoading (): any;

	protected abstract renderContent (): any;

	protected abstract renderTitle (): string;

	protected abstract renderDescription (): string;

	protected getCanonicalUrl (): string | null {
		return null;
	}

	protected getPageName () {
		return '';
	}

	protected isPadded () {
		return true;
	}

	protected shouldBeIndexed () {
		return true;
	}

	private typeset () {
		if (typeof MathJax === 'undefined') {
			setTimeout(() => this.typeset(), 50);
			return;
		}

		try {
			if (!Page.mathJaxIsConfigured) {
				MathJax.Ajax.config.path.mhchem = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax-mhchem/3.1.0';
				MathJax.Hub.Config({ TeX: { extensions: ['[mhchem]/mhchem.js'] }});

				MathJax.Hub.Configured();
				Page.mathJaxIsConfigured = true;
			}

			MathJax.Hub.Queue(['Typeset', MathJax.Hub, ReactDOM.findDOMNode(this)]);

		} catch (e) {
			return; // Catch MathJax is not defined exception
		}
	}
}

export default Page;


// WEBPACK FOOTER //
// ./code/project/pages/Page.tsx